/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import makeStore from './store';
import App from './App';
import ConfigHoc from './hoc/config.hoc';
import reportWebVitals from './reportWebVitals';
import './styles/sass/global.sass';

const store = makeStore();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: 'var(--primary-color)',
            colorText: 'var(--base-text-paragraph)',
            colorTextDisabled: 'var(--base-disable-color)',
            colorLink: 'var(--secondary-color)',
            colorLinkActive: 'var(--tertiary-color)',
            colorLinkHover: 'var(--primary-color)',
          }
        }}
      >
        <ConfigHoc>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ConfigHoc>
      </ConfigProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
